export const ENTER = [13, 'Enter'];
export const TAB = [9, 'Tab'];
export const UP = [38, 'ArrowUp'];
export const DOWN = [40, 'ArrowDown'];
export const ESC = [27, 'Escape'];
export const HOME = [36, 'Home'];
export const END = [35, 'End'];
